"use client";
import React, { useEffect, useState } from "react";
import FormSection from "./form-section/FormSection";
import PageTitle from "@/components/common-components/page-title/PageTitle";
import FaqSection from "@/components/common-components/faqs/FaqSection";
import axios from "axios";
import { fetchHeaderData } from "@/redux/organizationSlice";
import { useDispatch, useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import "./index.css";

import { generateCacheKey, withManualCache } from "@/utlility/cache-service";

const ContactUs = () => {
  const dispatch = useDispatch();
  const { headerData } = useSelector((state) => state?.organization);

  useEffect(() => {
    if (!headerData) {
      dispatch(
        fetchHeaderData({
          organization_key: process.env.NEXT_PUBLIC_ORGANIZATION_KEY,
        })
      );
    }
  }, [dispatch, headerData]);

  return (
    <>
      <PageTitle
        image="/images/contact-bg.webp"
        name="contact"
        link={"/contact-us"}
      />
      <FormSection addressData={{ data: headerData?.location }} headerData={headerData} />

      <section className="map-section">
        <Container>
          <iframe
            src={headerData?.location?.map_location}
            allowFullScreen
            aria-hidden="false"
            tabIndex={0}
            className="map"
          />
        </Container>
      </section>
      <FaqSection />
    </>
  );
};

export default ContactUs;
